<template>
  <div class="attendanceRecord" id="jobListsDiv">
    <!--添加求职意向  个人-->
    <el-dialog
        title=""
        class="telPop"
        :visible.sync="addMess"
        :destroy-on-close="zhen"
        width="650px"
        top="20vh"
        style="margin: 0 auto;text-align:center;z-index: 2000;border-radius: 10px;"
    >
      <div class="telPop-div" v-if="addMess">
        <div class="telPop-title" v-if="userInfos.user_nature == '1'">{{jobIntention.id?'编辑':'添加'}}求职意向</div>
        <div class="telPop-title" v-else>{{jobIntention.id?'编辑':'添加'}}招聘岗位</div>
        <hr style="width: 600px;margin-left: 0;">
        <el-form :model="jobIntention" :rules="rulesForm"  ref="redactMes" label-width="120px" class="demo-ruleForm">
          <el-form-item  :label="userInfos.user_nature == '1' ? language.jobThik : language.liveClass1 + ':'" prop="classifyVal">
            <el-cascader
                style="display: block;width: 468px;"
                v-model="jobIntention.classifyVal"
                :options="recruitList"
                @change="postMes"
                :placeholder="userInfos.user_nature == '1' ? language.inputPostName1 : language.postTips"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item style="position: relative;"  :label="userInfos.user_nature == '1' ? language.city2 : language.city + ':'" prop="city">
<!--            <el-input type="text" v-model="jobIntention.city" autocomplete="off" :placeholder="language.inputCity"></el-input>-->
            <el-input
                v-model="jobIntention.city"
                v-on:click.native="showArea"
                :readonly="true"
                :placeholder="userInfos.user_nature == '1' ? language.inputCity : language.locationTips"
                ref="wordLocation"
            ></el-input>
            <i :class="!areaVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="position: absolute;right: 132px;top: 13px;color: #C0C4CC"></i>
          </el-form-item>
          <el-form-item  :label="language.salaryScope + ':'" prop="salary">
<!--            <el-input type="text" v-model="jobIntention.salary" autocomplete="off" :placeholder="language.chanceSalary"></el-input>-->
            <el-select
                class="salarySelsect"
                style="display: block;width: 468px;height: 40px;"
                v-model="jobIntention.salary"
                :placeholder="language.chanceSalary"
                ref="salary"
            >
              <el-option
                  v-for="item in salaryList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  :label="userInfos.user_nature == '1' ? language.jobState :language.postSay + ':'" prop="details">
            <el-input type="textarea" rows="8" v-model="jobIntention.details" autocomplete="off" :placeholder="userInfos.user_nature == '1' ? language.inputJobState : language.postSayTips"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="warning"
                       style="width: 400px;height: 56px;background-color: #f47900;border-radius: 4px;color: #FFFFFF;font-size: 24px;float: left;margin-left: 0px;margin-top: 50px;"
                       @click="submit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>

    </el-dialog>

    <!--所在城市-->
    <area-div v-model="areaName" parentId="jobListsDiv" :areaEl="areaEl" :visible.sync="areaVisible" @areaVisibleEvent="areaVisibleEvent"/>
  </div>
</template>
<script>
  import {videoUrl} from "../../../common/url";
  import Cookie from "../../../common/cookie"
  import {getLanguage, language} from "../../../language/get";
import { attendanceRecord,findJogList } from "../../../api/btManage";
import searchBar from "../components/searchbar/searchbar";
// import searchPost from "../components/searchbar/searchpost";
import pubTable from "../components/table/table";
import tablePage from "../components/tablepage/tablepage";
import dragDialog from "../../../components/DragDialog/index";
import {LiveStateType} from "../../../common/constant/room";
import {callbackPlatVodio} from "../../../api/forum";
import pagination from "../../../components/Pagination/pagination";
import {mapGetters} from "vuex";
import {isEmpty} from "../../../common/validate";
import {stateEnum} from "./enum";
  import {getUserInfo} from "@/api/user";
  import {deletePostMess, selectRecruitPost, updatePostMess} from "@/api/exhibition";
  import areaDiv from  "@/components/area/index";
import { Notification, MessageBox, Message } from 'element-ui';
  import getParamter from "@/common/util";
const pubLanguage = language();




const columnsAppend = [
  {
    title: pubLanguage.state,
    key: "type",
    width: "150"
  },
  {
    title: pubLanguage.time,
    key: "truetime"
  }
] //嵌套

export default {
  components: {
    searchBar,
    pubTable,
    tablePage,
    dragDialog,
    pagination,
    areaDiv
  },
  computed: {
    ...mapGetters(["token", "userInfo"])
  },
  data() {
    return {
      zhen:true,
      qz:null,
      salaryNumber:"",
      areaVisible: false,
      areaName: '',
      areaEl: null,
      locationName:"",
      addMess:false, //添加求职意向或者岗位
      jobIntention:{
        classify:"",
        city:"",
        salary:"",
        details:""
      }, // 求职意向对象
      userInfos:{},
      recruitList:[],
      language: pubLanguage,
      dialogVisible: false,
      innerVisible: false, //嵌套弹窗
      innerLoading: false,
      loading:true,
      userId:null,
      lan: Cookie.get("lang"),
      stateEnum,
      //page
      pageTotal: 0,
      pageSize: 6,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      //搜索相关
      searchInputPlc: pubLanguage.studioFairName,
      searchSelectPlc: pubLanguage.classification,
      searchData: null,
      broadClass: [],
      rulesForm:[],
      salaryList:[
        {
          value:'1K-3K',
          label:"1K-3K"
        },{
          value:'3K-5K',
          label:"3K-5K"
        },{
          value:'5K-8K',
          label:"5K-8K"
        },{
          value:'8K-12K',
          label:"8K-12K"
        },{
          value:'12K以上',
          label:"12K以上"
        },
      ],
      attendanceRecordData: [],
      cloneData: [],
      fromData: {
        city: "",
        salary: "",
        classify: "",
      },
      //弹窗信息
      initCont: {}, //弹窗初始化内容
      columnCz: [], //参展弹窗,
      appendTitle: "",
      LiveStateType,
      currentPageAppend: 1,
      numberPageAppend: 6,
      tableData: [],
      empty: "",
      innerTotal: 0,
      liveRow: {},
      roomId: null,
      outerTitle: "",
      innerColumn: columnsAppend,
      width: "",
      fn: null
    };
  },
  created() {
    this.loadData();
    let user_nature = this.userInfo.user_nature;
    this.rulesForm = {
        details:[
          {
            required:true,
            message:user_nature==1?"请输入说明":"请输入说明",
            trigger:"blur"
          }
        ],
        city:[
          {
            required:true,
            // message:user_nature==1?"请选择城市":"请选择城市",
            trigger:"change",
            validator: this.homeValidator,
          }
        ],
        salary:[
          {
            required:true,
            message:user_nature==1?"请选择薪资范围":"请选择薪资范围",
            trigger:"blur"
          }
        ],
      classifyVal:[
          {
            required:true,
            message:user_nature==1?"请选择岗位":"请选择岗位",
            trigger:"blur"
          }
        ]
      };
  },
  methods: {
    homeValidator(rule, value, callback){
      console.log(value);
      if (!value) {
        let chLan = getLanguage('ch');
        callback(new Error(chLan.homeRules));
      }
      callback();
    },
    postMes(value){
      // console.log("什么信息==" , value)
      if(value != undefined) {
        this.jobIntention.classify = value[1];
      }

    },
    editJbo(item){
      this.jobIntention = {
        id: item.id,
        classify: item.classify,
        classifyVal:[item.jobc_super_id,item.jobc_id],
        city: item.city,
        salary: item.salary,
        details: item.details
      };
      this.addMess = true;
    },
    submit(){
      this.$refs.redactMes.validate((valid) => {
        if(!valid){
          return false;
        }
        if(this.userInfo.superioruser_id != 0){
          this.userId = this.userInfo.superioruser_id;
        }else {
          this.userId = this.userInfo.user_id;
        }
        // console.log(this.userId + "是谁？");
        let prop = {
          name:this.jobIntention.name,
          city:this.jobIntention.city,
          classify:this.jobIntention.classify,
          salary:this.jobIntention.salary,
          uid:this.userId,
          details:this.jobIntention.details
        };
        if(this.jobIntention.id){
          prop.id = this.jobIntention.id;
        }
        updatePostMess(prop).then(res =>{
          const height = document.body.clientHeight / 2;
          if(res.type == 2) {
            this.$message({
              showClose: true,
              message: res.text,
              type: "error",
              offset: height
            });
            this.addMess = true;
          }else if(res.type == 1){
            this.$message({
              showClose: true,
              message: "操作成功",
              type: "success",
              offset: height
            });
            this.addMess = false;
          }else{
            this.$message({
              showClose: true,
              message: res.text,
              type: "error",
              offset: height
            });
            this.addMess = false;
          }

          this.$emit("saveEvent",res);
        })

      })
    },
    areaVisibleEvent(visible){
      this.areaVisible = visible;
      this.jobIntention.city = this.areaName;
    },
    showArea(e){
      this.areaEl = e.target;
      this.areaName = this.jobIntention.city;
      this.areaVisible = true;
    },
    add() {
      this.jobIntention = {
        classify:"",
        city:"",
        salary:"",
        details:""
      };
      this.addMess = true;
    },
    loadData(){
      getUserInfo().then(res => {
        if (res.type != '1') {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
        this.userInfos = res.data[0];
        //console.log("222222222222" + this.userInfos.company_logo_url);
        if(this.userInfos.company_logo_url){
          this.imgList = [{ status: "success", url: this.userInfos.company_logo_url }];
        }else{
          this.imgList = [];
        }
        // this.gender1 = this.gender[this.userInfos.sex].label
       // console.log("233333==" + this.userInfos.register_area);

      });

      //获取招聘岗位
      selectRecruitPost({ exhibition_id: this.exhibitionId }).then((res) => {
        if(res.type == 1){
          const data = res.data;
          // console.log("data：", data);
          for(var index in data) {
            if (data[index].super_id == null) {
              this.recruitList.push({
                value: data[index].id,
                label: data[index].name,
                children: []
              })
            }
          }
          for(var index in data){
            if(data[index].super_id != null){
              for(var i in this.recruitList){
                if(this.recruitList[i].value == data[index].super_id){
                  // this.$set(this.recruitList[i],"children",data[index])
                  this.recruitList[i].children.push({
                    value:data[index].id,
                    label:data[index].name,
                    super_id:data[index].super_id
                  })
                }
              }
            }
          }
          // console.log("岗位：" , this.recruitList);
        }else{
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
      });
    },
    //展会门票列表
    attendanceRecordList() {
      let that = this;
      this.loading = true;
      let data = {
        token: this.$store.state.user.token,
        broadcast_class: that.fromData.broadcast_class,
        keyword: that.fromData.keyword,
        currentPage: that.currentPage,
        numberPage: that.pageSize,
      };
      attendanceRecord(data).then(res => {
        if (res.type == "1") {
          let data = res.data;
          if (typeof data == undefined || data == "" || data == null || isEmpty(data)) {
            this.pageTotal = res.datacount;
            this.attendanceRecordData = [];
            return;
          }
          data.forEach(item => {
            if (this.lan == "en") {
              item.broadcast_name = `${(item.broadcast_name_en||item.broadcast_name)||''}`;
              item.exh_name = `${(item.exh_name_en||item.exh_name)||''}`;
              item.exh_begtime = `${item.exh_begtime}`;
              item.exh_endtime = `${item.exh_endtime}`;
            }else{
              item.broadcast_name = `${item.broadcast_name||item.broadcast_name_en}`;
              item.exh_name = `${(item.exh_name||item.exh_name_en)||''}`;
            }
            item.exh_time = `${item.exh_begtime} ${pubLanguage.to} ${item.exh_endtime}`;
          });
          this.pageTotal = parseInt(res.datacount);
          this.attendanceRecordData = data;
        } else {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
      });
      this.loading = false;
    },
    setHeraderStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return `background-color: #F2F2F2;
                        color: #424242;
                        padding:7.5px 0;
                        font-size:14px;
                        border-top: 1px solid #e6e6e6 ;
                        border-bottom: 1px solid #e6e6e6 ;
                        font-weight: normal;
                        `;
      }
    },
    //弹窗信息
    handleCzInfo(row, initCont, fn) {
      if (this.stateEnum.COMPANY_LIST == fn) {
        this.appendTitle = `${pubLanguage.see}-${initCont.broadcast_name}-${row.turename}`;
        this.liveRow = row;
        this.roomId = initCont.broadcast_id;
        this.handleInnerData();
        this.innerVisible= true;
        return;
      }
      const props = {
        roomid: initCont.broadcast_id,
        broadcast_playback_id: row.broadcast_playback_id
      };
      window.open(videoUrl(props));
      // window.location.href = videoUrl(props);
      return;
    },
    getPagination(val){
      this.currentPageAppend = val.page;
      this.handleInnerData();
    },
    //下载谷歌浏览器
    download() {
      window.open("https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds")
    }
  },
  watch: {
    innerVisible() {
      if (!this.innerVisible) {
          this.empty = "";
          this.innerTotal = 0;
          this.tableData = [];
          this.currentPageAppend = 1;
          this.numberPageAppend = 6;
      }
    },
  }
};
</script>

<style scoped>
  .telPop-div .el-form {
    margin-top: 20px;
  }
  .telPop-div >>> .el-form-item {
    margin-bottom: 15px;
    margin-left: -10px;
  }
  .telPop-div .el-select {
    display: block;
  }
  .telPop-div .el-select >>> .el-input__inner{
    margin-bottom: 15px;
  }
  .telPop-div >>> .el-form-item__label {
    width: 69px;
    height: 16px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333333;
  }
  .telPop-div >>> .el-form-item__content .el-input__inner,
  .telPop-div >>> .el-form-item__content .el-textarea__inner{
    width: 468px;
    /*height: 39px;*/
    background-color: #eff0f1;
    border-radius: 5px;
    float: left;
  }
  .telPop-title{
    text-align: left;
    font-size: 24px;
    color: #363636;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .prompt-info-wrap{
    width: 940px;
    padding: 10px 0 5px 5px;
    background: #fcf6f2;
    margin-bottom: 10px;
    margin-top: 20px;
    border-radius: 5px;
  }
.prompt-info{
  height:30px;
  line-height:30px;
  /*background:#fff;*/
  padding-left:15px;
  color:#ed6c00;
  font-size:16px;
  font-weight:bold;
}
.prompt-info span{
  color:#0f408a;
  cursor:pointer;
}
.kong {
  width: 993px;
  height: 382px;
  background: url("../../../assets/img/wu.png");
  background-size: 100% 100%;
}
  .messJob {
    width: 993px;
    /*height: 255px;*/
    background-color: #ffffff;
    border-radius: 5px;
    font-size: 16px;
    margin-bottom: 20px;
    font-family: SourceHanSansCN-Regular;
  }
  .messName {
    height: 20px;
    font-family: SourceHanSansCN-Bold;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #0071ff;
    padding: 20px 0 10px 15px;
  }
  .mess-div {
    font-size: 16px;
    color: #333333;
    padding-left: 20px;
    margin-top: 20px;
  }
  .content {
    min-height: 50px;
  }
  .attendanceRecord >>> .tableNode{
    padding: 30px;
    border-radius: 5px;
  }
  .attendanceRecord >>> .tableNode .el-table{
    border: 1px solid #f2f2f2 !important;
    min-height: 420px;
  }
  .attendanceRecord >>> .el-table th>.cell{
    border-right:none;
  }

  .attendanceRecord >>> .el-pagination .el-pager li{
    width: 30px;
    height: 30px;
    line-height: 30px;
    background:none;
    font-size: 14px;
  }
  .attendanceRecord >>> .el-pagination {
    margin-right: 180px;
  }
  .attendanceRecord >>> .el-pagination .btn-next{
    width: 60px;
    height: 30px;
    line-height: 30px;
    background: #FFFFFF;
  }
  .attendanceRecord >>> .el-pagination .btn-prev{
    width: 60px;
    height: 30px;
    line-height: 30px;
    background: #FFFFFF;
  }

  .attendanceRecord >>> .el-pagination .el-input__inner{
    width: 30px;
    height: 30px;
    line-height: 25px;
    margin-top: -15px !important;
  }
  .attendanceRecord >>> .el-pagination .el-pagination__jump{
    width: 25px;
    height: 25px;
    line-height: 25px;
  }
  .attendanceRecord >>> .tiaozhuan{
    margin-left: -100px !important;
  }
</style>
<style>
  .salarySelsect .el-input{
    height: 40px;
  }
  .el-form-item__error{
    padding: 0px;
  }
  .dialog_children .el-dialog {
    padding: 20px
  }
  .dialog_children .el-dialog__header{
    padding: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #a1a1a1;
  }
  .dialog_children .el-dialog__title {
    font-size: 14px;
    line-height: 14px;
  }
  .dialog_children .el-dialog__body {
    padding: 0;
    padding-bottom: 40px;
  }
  .dialog_children .el-table .cell {
    padding-left: 20px;
  }
</style>
